import { graphql } from "react-relay";

export const ValidateAccountMutation = graphql`
  mutation ValidateAccountMutation($input: ValidateAccountInput!) {
    validateAccount(input: $input) {
      account {
        email
        id
        key
        name
        path
        provider
        securityContext
        statusInfo {
          details {
            at
            component
            message
            status
          }
        }
      }
    }
  }
`;
